// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* 隐藏滚动条 */
.scrollbar-hide[data-v-712c47a3] {
  -ms-overflow-style: none; /* IE 和 Edge */
  scrollbar-width: none; /* Firefox */
}
.scrollbar-hide[data-v-712c47a3]::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

/* 滚动容器包装器 */
.scroll-wrapper[data-v-712c47a3] {
  position: relative;
}

/* 滚动容器 */
.scroll-container[data-v-712c47a3] {
  position: relative;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch; /* iOS 平滑滚动 */
}

/* 桌面端：使用 scroll-snap */
@media (min-width: 768px) {
.scroll-container[data-v-712c47a3] {
    scroll-snap-type: x mandatory;
}
.scroll-item[data-v-712c47a3] {
    scroll-snap-align: start;
}
}

/* 图片加载优化 */
.scroll-item img[data-v-712c47a3] {
  will-change: transform;
}

/* 收藏图标悬停效果 */
.scroll-item .van-icon[data-v-712c47a3] {
  transition: transform 0.2s ease;
}
.scroll-item .van-icon[data-v-712c47a3]:hover {
  transform: scale(1.1);
}

/* 导航箭头按钮 */
.nav-arrow[data-v-712c47a3] {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}
.nav-arrow[data-v-712c47a3]:hover:not(:disabled) {
  background: #f7f7f7;
  border-color: #d0d0d0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
.nav-arrow[data-v-712c47a3]:active:not(:disabled) {
  transform: scale(0.95);
}

/* 禁用状态 */
.nav-arrow-disabled[data-v-712c47a3] {
  cursor: not-allowed;
  background: #f5f5f5;
  border-color: #e5e5e5;
  opacity: 0.5;
}
.nav-arrow-disabled[data-v-712c47a3]:hover {
  background: #f5f5f5;
  border-color: #e5e5e5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
